import client from '../../../helpers/client';
import cognito from '../../../helpers/cognito';

export const getListChallengeByBounty = (params) => {
  return async () => {
    const { bountyId, page, limit } = params;
    const queryParams = new URLSearchParams({
      bounty_id: bountyId,
      page,
      limit
    }).toString();
    
    return client
      .api(`/bounty-challenges?${queryParams}`, 'get', { headers: await cognito.getHeaderAuthorization() })
      .then(({ data: response }) => {
        return response;
      })
      .catch((err) => {
        return null;
      });
  };
};

export const createChallenge = (data) => {
  return async () => {
    return client
      .api('/bounty-challenges', 'post', data,
        { headers: await cognito.getHeaderAuthorization() }
      )
      .then(({ data: response }) => {
        return response;
      })
      .catch((err) => {
        return null;
      });
  };
};

export const updateChallenge = (challengeId, data) => {
  return async () => {
    return client
      .api(`/bounty-challenges/${challengeId}`, 'put', data,
        { headers: await cognito.getHeaderAuthorization() }
      )
      .then(({ data: response }) => {
        return response;
      })
      .catch((err) => {
        return null;
      });
  };
};

export const deleteChallenge = (challengeId) => {
  return async () => {
    return client
      .api(`/bounty-challenges/${challengeId}`, 'delete', { headers: await cognito.getHeaderAuthorization() })
      .then(({ data: response }) => {
        return response;
      })
      .catch((err) => {
        return null;
      });
  };
};


export const getListMentorsByChallenge = (params) => {
  return async () => {
    const { challengeId, page, limit } = params;
    const queryParams = new URLSearchParams({
      challengeId: challengeId,
      page,
      limit
    }).toString();

    return client
      .api(`/challenge-mentors?${queryParams}`, 'get', { headers: await cognito.getHeaderAuthorization() })
      .then(({ data: response }) => {
        return response;
      })
      .catch((err) => {
        return null;
      });
  };
};


export const getListMentorsByBounty = (params) => {
  return async () => {
    const { bountyId } = params;
    const queryParams = new URLSearchParams({
      bountyId: bountyId,
      page: 1,
      limit: 100
    }).toString();

    return client
      .api(`/mentors?${queryParams}`, 'get', { headers: await cognito.getHeaderAuthorization() })
      .then(({ data: response }) => {
        return response;
      })
      .catch((err) => {
        return null;
      });
  };
};


export const addMentorToChallenge = (data) => {
  return async () => {
    return client
      .api('/challenge-mentors', 'post', data,
        { headers: await cognito.getHeaderAuthorization() }
      )
      .then(({ data: response }) => {
        return response;
      })
      .catch((err) => {
        return null;
      });
  };
};

export const inactiveMentorToChallenge = (data) => {
  return async () => {
    return client
      .api(`/challenge-mentors/${data.id}`, 'put', data,
        { headers: await cognito.getHeaderAuthorization() }
      )
      .then(({ data: response }) => {
        return response;
      })
      .catch((err) => {
        return null;
      });
  };
};

export const deleteMentorToChallenge = (data) => {
  return async () => {
    return client
      .api(`/challenge-mentors/${data.id}`, 'DELETE', { headers: await cognito.getHeaderAuthorization() }
      )
      .then(({ data: response }) => {
        return response;
      })
      .catch((err) => {
        return null;
      });
  };
};


export const getListEvaluations = () => {
  return async () => {
    const queryParams = new URLSearchParams({
      page: 1,
      limit: 100
    }).toString();

    return client
      .api(`/evaluations?${queryParams}`, 'get', { headers: await cognito.getHeaderAuthorization() })
      .then(({ data: response }) => {
        return response;
      })
      .catch((err) => {
        return null;
      });
  };
};

export const createRound = (data) => {
  return async () => {
    return client
      .api('/challenge-rounds', 'post', data,
        { headers: await cognito.getHeaderAuthorization() }
      )
      .then(({ data: response }) => {
        return response;
      })
      .catch((err) => {
        return null;
      });
  };
};

export const getListRound = (params) => {
  return async () => {
    const { challengeId, page = 1, limit = 100 } = params;
    const queryParams = new URLSearchParams({
      challengeId,
      page,
      limit
    }).toString();
    
    return client
      .api(`/challenge-rounds?${queryParams}`, 'get', { headers: await cognito.getHeaderAuthorization() })
      .then(({ data: response }) => {
        return response;
      })
      .catch((err) => {
        return null;
      });
  };
};

export const editRound = (roundId, data) => {
  return async () => {
    return client
      .api(`/challenge-rounds/${roundId}`, 'put', data,
        { headers: await cognito.getHeaderAuthorization() }
      )
      .then(({ data: response }) => {
        return response;
      })
      .catch((err) => {
        return null;
      });
  };
};

export const deleteRound = (roundId) => {
  return async () => {
    return client
      .api(`/challenge-rounds/${roundId}`, 'delete', { headers: await cognito.getHeaderAuthorization() })
      .then(({ data: response }) => {
        return response;
      })
      .catch((err) => {
        return null;
      });
  };
};

export const getSubmissionRound = (params) => {
  return async () => {
    const { roundId } = params;
    const queryParams = new URLSearchParams({
      roundId
    }).toString();
    
    return client
      .api(`/submission-rounds?${queryParams}`, 'get', { headers: await cognito.getHeaderAuthorization() })
      .then(({ data: response }) => {
        return response;
      })
      .catch((err) => {
        return null;
      });
  };
};

